import Table from "components/Table";
import Navbar from "components/Navbar";
import Footer from "components/Footer";
import BarChart from "components/BarChart";
import DonutChart from "components/DonutChart";

const Dashboard = () => (
  <>
    <Navbar />
    <div className="container">
      <h1 className="text-primary py-3">Dashboard de Vendas</h1>

      <div className="row py-3">
        <div className="col-sm-6">
          <h5 className="text-center text-secondary">Taxa de Sucesso (%)</h5>
          <BarChart />
        </div>

        <div className="col-sm-6">
          <h5 className="text-center text-secondary">Todas as vendas</h5>
          <DonutChart />
        </div>
      </div>

      <div className="py-3">
        <h2 className="text-primary">
          Todas as vendas
          </h2>

        <Table />
      </div>
    </div>
    <Footer />
  </>
);

export default Dashboard;
